export default function qs(params) {
    return Object.keys(params)
      .filter((key) => params[key] !== undefined && params[key] !== null)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
  }



export const isValidUrl = (urlString) => {
    if (!urlString) return false;

    const isLocalEnv = process.env.REACT_APP_API_URL?.includes('localhost');

    // eslint-disable-next-line no-useless-escape
    const localhostUrlPattern = /^http:\/\/localhost(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;

    const prodUrlPattern = new RegExp(
        '^https?:\\/\\/' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?' +
        '(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$','i'
    );

    const result = isLocalEnv
        ? localhostUrlPattern.test(urlString)
        : prodUrlPattern.test(urlString);

    return result;
};

